/* Rebel Nell — Holiday Gift Guide sections (gg-*) */
(function () {
  if (window.__ggGiftGuide) return;
  window.__ggGiftGuide = true;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var dayStart = function (iso) { return new Date(iso + 'T00:00:00'); };
  var dayEnd = function (iso) { return new Date(iso + 'T23:59:59'); };
  var validIso = function (s) { return /^\d{4}-\d{2}-\d{2}$/.test((s || '').trim()); };

  /* ── Info bar: hide messages outside their date window ── */
  function initSchedule(root) {
    $$('[data-gg-schedule]', root).forEach(function (box) {
      if (box.hasAttribute('data-design-mode')) return;
      var now = new Date();
      $$('[data-gg-sched-item]', box).forEach(function (item) {
        var s = item.getAttribute('data-start'), e = item.getAttribute('data-end');
        if ((validIso(s) && now < dayStart(s)) || (validIso(e) && now > dayEnd(e))) item.remove();
      });
      if (box.getAttribute('data-gg-schedule') === 'remove-empty' && !$('[data-gg-sched-item]', box)) box.remove();
    });
  }

  /* ── Guide nav: tabs + keep the current tile in view on mobile ── */
  function selectTab(nav, tab) {
    $$('.gg-tab', nav).forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }
  function initNav(root) {
    $$('[data-gg-nav]', root).forEach(function (nav) {
      var cur = $('.gg-tile[aria-current="page"]', nav);
      if (cur) {
        var strip = cur.parentElement;
        if (strip.scrollWidth > strip.clientWidth) strip.scrollLeft = cur.offsetLeft - 16;
      }
    });
  }

  /* ── Sticky filter bar sits under the theme's sticky header ── */
  function headerOffset() {
    var max = 0;
    $$('header, [class*="header"], [id*="header"], [id*="Header"]').forEach(function (el) {
      if (el.closest('.gg')) return;
      var cs = getComputedStyle(el);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && parseFloat(cs.top || 0) <= 4) {
        var r = el.getBoundingClientRect();
        if (r.top <= 4 && r.bottom > max && r.height < window.innerHeight / 2) max = r.bottom;
      }
    });
    return Math.max(0, Math.round(max));
  }
  var ticking = false;
  function setOffset() {
    ticking = false;
    var h = headerOffset() + 'px';
    $$('[data-gg-shop]').forEach(function (s) { s.style.setProperty('--gg-sticky-top', h); });
    document.body.style.setProperty('--gg-sticky-top', h);
  }
  function queueOffset() { if (!ticking) { ticking = true; requestAnimationFrame(setOffset); } }

  /* ── Shipping: strike past dates, highlight the next one, countdown ── */
  function initShip(root) {
    $$('[data-gg-ship]', root).forEach(function (sec) {
      var now = new Date(), nextSet = false;
      $$('.gg-rows li', sec).forEach(function (li) {
        var d = li.getAttribute('data-date'), st = $('[data-gg-status]', li);
        li.classList.remove('is-past', 'is-next');
        if (!validIso(d)) return;
        if (now > dayEnd(d)) { li.classList.add('is-past'); if (st) st.textContent = 'Passed'; }
        else if (!nextSet) { nextSet = true; li.classList.add('is-next'); if (st) st.textContent = 'Next cutoff'; }
      });
      var cd = $('[data-gg-countdown]', sec);
      if (cd) {
        var target = cd.getAttribute('data-gg-countdown');
        if (validIso(target)) {
          var days = Math.ceil((dayEnd(target) - now) / 864e5);
          if (days >= 1) { $('[data-gg-days]', cd).textContent = days; cd.hidden = false; }
          else cd.hidden = true;
        }
      }
    });
  }

  /* ── Filter drawer (moved to <body> so theme animations can't trap it) ── */
  function portal(el) { if (el && el.parentElement !== document.body) document.body.appendChild(el); return el; }
  var lastOpener = null;
  function openDrawer(btn) {
    var drawer = portal(document.getElementById(btn.getAttribute('aria-controls')));
    if (!drawer) return;
    portal(document.getElementById(drawer.id.replace('GgDrawer', 'GgScrim')));
    lastOpener = btn;
    document.body.classList.add('gg-drawer-open');
    document.documentElement.style.overflow = 'hidden';
    var first = $('input:not([disabled]), button', drawer);
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
  }
  function closeDrawer() {
    if (!document.body.classList.contains('gg-drawer-open')) return;
    document.body.classList.remove('gg-drawer-open');
    document.documentElement.style.overflow = '';
    if (lastOpener) lastOpener.focus({ preventScroll: true });
  }

  /* ── Load more (Section Rendering API) ── */
  function loadMore(btn) {
    var shop = btn.closest('[data-gg-shop]');
    var url = btn.getAttribute('href');
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Loading…';
    fetch(url + sep + 'section_id=' + encodeURIComponent(shop.getAttribute('data-section-id')))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-gg-grid]', shop);
        $$('[data-gg-grid] > .gg-card', doc).forEach(function (card) { grid.appendChild(card); });
        var more = $('[data-gg-more]', doc);
        $('[data-gg-more]', shop).replaceWith(more || document.createElement('div'));
      })
      .catch(function () { window.location.href = url; });
  }

  /* ── Quick add ── */
  var toastTimer;
  function showToast(shop, head, text, img) {
    var t = portal(document.getElementById(shop.getAttribute('data-toast')));
    if (!t) return;
    $('[data-gg-toast-head]', t).textContent = head;
    $('[data-gg-toast-text]', t).textContent = text || '';
    var im = $('[data-gg-toast-img]', t);
    if (img) { im.src = img; im.style.display = ''; } else { im.style.display = 'none'; }
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }
  function updateBubble() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('.cart-link__bubble-num, [data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        $$('.cart-link__bubble').forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0); });
      }).catch(function () {});
  }
  function quickAdd(btn) {
    var shop = btn.closest('[data-gg-shop]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var mode = shop.getAttribute('data-quick-add') || 'drawer';
    btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-gg-add')), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (data) {
        var item = data.items ? data.items[0] : data;
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (mode === 'drawer') {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } }));
        } else {
          showToast(shop, 'Added to cart', btn.getAttribute('data-gg-name'), btn.getAttribute('data-gg-img'));
        }
        updateBubble();
      })
      .catch(function (err) {
        showToast(shop, 'Couldn’t add to cart', (err && (err.description || err.message)) || 'Please try again.', '');
      })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }


  /* ── Product picks: choose graffiti piece / size / metal, then add to cart ── */
  var MAX_THUMBS = 12;
  function pickData(card) {
    if (!card.__gg) {
      var el = $('[data-gg-variants]', card);
      var vs = [];
      try { vs = el ? JSON.parse(el.textContent) : []; } catch (e) { vs = []; }
      card.__gg = { variants: vs, opts: $$('[data-gg-opt]', card) };
    }
    return card.__gg;
  }
  function selected(d) {
    return d.opts.map(function (o) {
      var b = $('[aria-pressed="true"]', o);
      return b ? b.getAttribute('data-val') : null;
    });
  }
  function matchAvail(vs, sel, skip) {
    return vs.filter(function (v) {
      if (!v.a) return false;
      for (var i = 0; i < sel.length; i++) if (i !== skip && sel[i] !== null && v.o[i] !== sel[i]) return false;
      return true;
    });
  }
  function money(c) { var s = (c / 100).toFixed(2); return '$' + s.replace(/\.00$/, ''); }
  function refreshPick(card, changed) {
    var d = pickData(card);
    if (!d.opts.length) return;
    var sel = selected(d);
    var exact = d.variants.filter(function (v) { return v.o.every(function (x, i) { return x === sel[i]; }); })[0];
    if (!exact || !exact.a) {
      /* keep the option the shopper just chose, pick the first available match for the rest */
      var keep = sel.map(function (x, i) { return i === changed ? x : null; });
      var alt = matchAvail(d.variants, keep, -1)[0] || matchAvail(d.variants, sel.map(function () { return null; }), -1)[0];
      if (alt) { sel = alt.o.slice(); exact = alt; }
    }
    d.opts.forEach(function (o, i) {
      var avail = {};
      matchAvail(d.variants, sel, i).forEach(function (v) { avail[v.o[i]] = 1; });
      var piece = o.getAttribute('data-kind') === 'piece';
      var shown = 0, extra = 0;
      $$('button[data-val]', o).forEach(function (b) {
        var val = b.getAttribute('data-val');
        b.setAttribute('aria-pressed', val === sel[i] ? 'true' : 'false');
        if (piece) {
          b.hidden = !avail[val];
          b.classList.remove('is-extra');
          if (!b.hidden) {
            shown++;
            if (shown > MAX_THUMBS && !o.hasAttribute('data-expanded') && val !== sel[i]) { b.classList.add('is-extra'); extra++; }
          }
        } else if (avail[val]) b.removeAttribute('data-unavailable');
        else b.setAttribute('data-unavailable', '');
      });
      var more = $('.gg-pick__more', o);
      if (extra) {
        if (!more) {
          more = document.createElement('button');
          more.type = 'button';
          more.className = 'gg-pick__more';
          $('.gg-pick__thumbs', o).appendChild(more);
        }
        more.textContent = '+' + extra + ' more';
        more.hidden = false;
      } else if (more) more.hidden = true;
      var lab = $('[data-gg-opt-val]', o);
      if (lab) {
        var shownVal = sel[i] || '';
        if (piece && /^\d+$/.test(shownVal)) shownVal = '#' + shownVal;
        lab.textContent = shownVal;
      }
    });
    var btn = $('.gg-pick__add', card);
    var price = $('[data-gg-pick-price]', card);
    if (exact && exact.a) {
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-label') || 'Add to Cart';
      btn.setAttribute('data-gg-add', exact.id);
      if (exact.t) btn.setAttribute('data-gg-img', exact.t);
      if (price) price.innerHTML = exact.c > exact.p ? '<span class="is-sale">' + money(exact.p) + '</span><s>' + money(exact.c) + '</s>' : money(exact.p);
    } else {
      btn.disabled = true;
      btn.textContent = 'Sold out';
    }
    if (changed !== undefined && exact && exact.i) {
      var img = $('.gg-pick__img--main', card);
      if (img) { img.removeAttribute('srcset'); img.src = exact.i; card.classList.add('is-picked'); }
    }
  }
  function initPicks(root) {
    $$('[data-gg-pick]', root).forEach(function (card) { refreshPick(card); });
  }

  /* ── Events (delegated, so they survive theme-editor reloads) ── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var tab = t.closest('.gg-tab');
    if (tab) { selectTab(tab.closest('[data-gg-nav]'), tab); return; }

    var open = t.closest('[data-gg-open-filters]');
    if (open) { openDrawer(open); return; }

    var close = t.closest('[data-gg-close-filters]');
    if (close) { closeDrawer(); return; }

    var more = t.closest('[data-gg-load-more]');
    if (more) { e.preventDefault(); if (!more.hasAttribute('aria-busy')) loadMore(more); return; }

    var arrow = t.closest('[data-gg-prev],[data-gg-next]');
    if (arrow) {
      var tr = $('[data-gg-track]', arrow.closest('[data-gg-carousel]'));
      if (tr) tr.scrollBy({ left: (arrow.hasAttribute('data-gg-next') ? 1 : -1) * tr.clientWidth * 0.9, behavior: 'smooth' });
      return;
    }

    var opt = t.closest('.gg-pick__thumb, .gg-pick__pill');
    if (opt) {
      var o = opt.closest('[data-gg-opt]');
      $$('button[data-val]', o).forEach(function (b) { b.setAttribute('aria-pressed', b === opt ? 'true' : 'false'); });
      refreshPick(opt.closest('[data-gg-pick]'), Number(o.getAttribute('data-gg-opt')));
      return;
    }
    var moreT = t.closest('.gg-pick__more');
    if (moreT) {
      var oo = moreT.closest('[data-gg-opt]');
      oo.setAttribute('data-expanded', '');
      refreshPick(moreT.closest('[data-gg-pick]'));
      return;
    }

    var add = t.closest('[data-gg-add]');
    if (add) { e.preventDefault(); if (!add.hasAttribute('aria-busy')) quickAdd(add); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
    var tab = e.target.closest && e.target.closest('.gg-tab');
    if (tab && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      var tabs = $$('.gg-tab', tab.parentElement), i = tabs.indexOf(tab);
      var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      selectTab(tab.closest('[data-gg-nav]'), next); next.focus();
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-gg-sort]');
    if (!sel) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-gg-filter-form]');
    if (!form) return;
    $$('input', form).forEach(function (i) { if ((i.type === 'number' || i.type === 'text') && i.value === '') i.disabled = true; });
  });

  function initCarousels(root) {
    $$('[data-gg-carousel]', root).forEach(function (c) {
      var tr = $('[data-gg-track]', c), prev = $('[data-gg-prev]', c), next = $('[data-gg-next]', c);
      if (!tr || !prev || !next) return;
      var upd = function () {
        prev.disabled = tr.scrollLeft < 4;
        next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
      };
      tr.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  function init(root) { initSchedule(root); initNav(root); initShip(root); initCarousels(root); initPicks(root); queueOffset(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  window.addEventListener('resize', queueOffset);
  window.addEventListener('scroll', queueOffset, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
/* Gift guide jump links: makes #holiday-offer, #holiday-shipping, #holiday-returns etc. jump reliably */
(function () {
  if (window.__ggJump) return;
  window.__ggJump = true;
  function findTarget(id) {
    var el = document.getElementById(id);
    if (el) return el;
    var boxes = document.querySelectorAll('.gg-ship .gg-fine > div');
    if (id === 'holiday-returns' && boxes.length > 1) return boxes[0];
    if (id === 'holiday-offer' && boxes.length) return boxes[boxes.length - 1];
    return null;
  }
  function headerOffset() {
    var max = 0;
    document.querySelectorAll('header, [class*="header"], [id*="header"], [id*="Header"]').forEach(function (el) {
      var cs = getComputedStyle(el);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && parseFloat(cs.top || 0) <= 4) {
        var r = el.getBoundingClientRect();
        if (r.top <= 4 && r.bottom > max && r.height < window.innerHeight / 2) max = r.bottom;
      }
    });
    return max;
  }
  function jump(id) {
    var el = findTarget(id);
    if (!el) return false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 20;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, Math.max(0, top));
    document.documentElement.style.scrollBehavior = '';
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var url = new URL(a.getAttribute('href'), window.location.href);
    if (url.pathname !== window.location.pathname || url.hash.length < 2) return;
    if (jump(decodeURIComponent(url.hash.slice(1)))) {
      e.preventDefault();
      history.replaceState(null, '', url.hash);
    }
  }, true);
  window.addEventListener('load', function () {
    setTimeout(function () {
      if (window.location.hash.length > 1) jump(decodeURIComponent(window.location.hash.slice(1)));
    }, 300);
  });
})();